import { observer } from 'mobx-react-lite'
import { FullProfilePage } from 'page/ProfileScreen/FullProfilePage/FullProfilePage'
import { SelfieProfilePage } from 'page/ProfileScreen/pages/SelfieProfilePage'
import { SimpleProfilePage } from 'page/ProfileScreen/Simple/SimpleProfilePage'
import { store } from 'store/store'

export const StandProfilePage = observer(() => {
  const key = store.profile?.identity_id || 'none'
  const photo = store.profile?.type

  if (photo === 'full') return <FullProfilePage key={key} />
  if (photo === 'simple') return <SimpleProfilePage key={key} />
  return <SelfieProfilePage key={key} />
})
